export const formatDate = (date) => {
  if (date) {
    return moment(date).format('YYYY-MM-DD hh:mm A');
  }
}

export const ENGLISH_TRANSLATIONS = {
  profile: 'Profile',
  CDN: 'CDN',
  'File Transcoding': 'File Transcoding',
  'Live Transcoding': 'Live Transcoding',
  logout: 'Logout',
  'New Endpoint': 'New Endpoint',
  Dashboard: 'Dashboard',
  Endpoints: 'Endpoints',
  'Start New Job': 'Start New Job',
  Jobs: 'Jobs',
  'Watch Folders': 'Watch Folders',
  'Encoding Profiles': 'Encoding Profiles',
  'Start New Stream': 'Start New Stream',
  Distributions: 'Distributions',
  DVR: 'DVR',
  'Add New Record': 'Add New Record',
  Recordings: 'Recordings',
  of: 'of',
  email: 'Email Address',
  email_placeholder: 'Email',
  password: 'Password',
  forgotten_password: 'Forgotten Password?',
  sign_in: 'Sign In',
  sign_up_text: 'Don\'t you have account?',
  sign_up: 'Sign Up Here',
  enter_email: 'Enter Email',
  non_empty_err: 'This field must not be empty',
  valid_email_err: 'Please provide a valid email address',
  unique_email_err: 'This email is already registered',
  name: 'Name',
  enter_name: 'Enter your name',
  company: 'Company',
  enter_company: 'Enter your company name',
  enter_password: 'Enter Password',
  password_min_len_err: 'Password must be at least 6 characters',
  confirm_password: 'Confirm Password',
  repeat_password: 'Repeat password',
  passwords_not_match_err: 'The passwords do not match',
  accept_terms: 'Accept Terms of Use',
  create_account: 'Create Account',
  already_have_account: 'Already have account?',
  signup_confirmation: 'Signup Confirmation',
  confirm_text: 'We sent you an activation code. Check you email and click on the link to verify.',
  return_to_sign_in: 'Return to Sign In',
  submit: 'Submit',
  password_reset_sent: 'Password Reset Sent',
  password_reset_text: 'We\'ve emailed you instructions for setting your password, if an account exists with the email you entered. You should receive them shortly. If you don\'t receive an email, please make sure you\'ve entered the address you registered with, and check your spam folder.',
  edit_profile_btn: 'Edit Profile',
  change_my_password: 'Change My Password',
  edit_profile_header: 'Edit Profile',
  save_changes: 'Save Changes',
  profile_popup_success: 'Profile Successfully Updated',
  change_password_header: 'Change Password',
  current_password: 'Current password*',
  new_password: 'New password*',
  confirm_new_password: 'Confirm new password*',
  change_password_btn: 'Change Password',
  password_change_popup: 'Password Successfully Updated',
  overview: 'Overview',
  traffic_total: 'Traffic total',
  cached_non_cached: 'Cached VS Non-Cached',
  endpoint: 'Endpoint',
  traffic: 'Traffic',
  cached: 'Cached',
  no_traffic: 'You didn\'t transfer any data through CDN yet.',
  edit_endpoint: 'Edit Endpoint',
  new_endpoint_text: 'Please provide a name for your endpoint and indicate where we get the data:',
  title_label: 'Name*',
  title: 'Title',
  title_req_err: 'Name is required',
  title_min_err: 'Title must be between 3 and 255 characters',
  ip_domain: 'IP Address or Domain Name*',
  http_hint: 'http:// only',
  invalid_ip: 'Invalid IP',
  required: 'required',
  whitelist: 'Whitelist',
  whitelist_text: 'Provide a list of IPv4 hosts/ip networks to be allowed by this CDN end-point. Any changes require up to 1 hour to be applied.',
  host: 'Host',
  subnet: 'Subnet',
  mask: 'Mask',
  add_btn: 'Add',
  create_btn: 'Create',
  save_btn: 'Save',
  save_changes_popup: 'Your changes have been saved',
  new_endpoint_popup: 'Your new endpoint has been successfully created. It will be ready in all our locations in about 30-60 minutes.',
  status: 'Status',
  updated: 'Last Update Time',
  no_cdn_text: 'You haven\'t set up any CDN Endpoint yet',
  endpoint_info: 'Endpoint Info',
  created: 'Created',
  state: 'State',
  error: 'Error',
  origin_URL: 'Origin URL',
  whitlist_list: 'IP whitelist(s)',
  no_whitelist: 'No IP restrictions set',
  delete_btn: 'Delete',
  disable_btn: 'Disable',
  enable_btn: 'Enable',
  disabled: 'Disabled',
  edit_btn: 'Edit',
  confirm_deletion: 'Confirm Deletion',
  enter_endpoint: 'Enter endpoint name*',
  enter_live_stream_name: 'Enter stream name*',
  endpoint_remove_popup: 'Endpoint successfully removed',
  yes_btn: 'Yes',
  no_btn: 'No',
  add_profile: 'Add New Profile',
  codecs: 'Codecs',
  resolution: 'Resolution',
  video_bitrate: 'Video Bitrate',
  audio_bitrate: 'Audio Bitrate',
  no_profiles: 'You haven\'t created any profile yet.',
  audio: 'Audio',
  channels: 'Channels',
  bitrate: 'Bitrate',
  sample_rate: 'Sample rate',
  video: 'Video',
  encoder: 'Encoder',
  streams: 'Streams',
  level: 'Level',
  bitrate_kbps: 'Bitrate, Kbps',
  resize_mode: 'Resize Mode',
  frame_rate: 'Frame Rate',
  ref_frames: 'Ref Frames',
  warning: 'Warning',
  delete_profile_warning: 'Deleting the profile will lead to deleting all transcoding tasks associated with it. Make sure that no important tasks are associated with this profile.',
  proceed: 'Are you sure you want to proceed?',
  profile_name_enter: 'Please enter profile name',
  profile_max_len_err: 'Name must be less than 255 characters',
  invalid_profile_name_err: 'Wrong profile name',
  new_profile_title: 'Create New Encoding Profile',
  edit_encoding_profile_header: 'Edit Encoding Profile',
  profile_name_text: 'Specify profile name (at least one character):',
  profile_name_label: 'Profile name*',
  profile_audio_text: 'Select audio settings:',
  codec_label: 'Codec*',
  sample_rate_label: 'Sample rate*',
  channel_count_label: 'Channel count*',
  bitrate_label: 'Bitrate*',
  custom_bitrate_label: 'Custom bitrate*',
  bitrate_required: 'Bitrate is required',
  bitrate_size_err: 'Bitrate must be between 0 and 1024 Kbps',
  bitrate_video_size_err: 'Bitrate must be between 1 and 50000 Kbps',
  same_as_source: 'Same as source',
  mono: 'Mono',
  stereo: 'Stereo',
  profile_video_text: 'Select a video codec and specify one or several video streams:',
  encoder_label: 'Encoder*',
  stream: 'Stream',
  at_least_one_stream: 'At least one stream should be provided',
  new_video_stream_btn: 'Add New Stream',
  edit_video_stream_btn: 'Edit Stream',
  new_video_stream_label: 'New Video Stream',
  edit_video_stream_label: 'Edit Stream',
  level_label: 'Level*',
  profile_label: 'Profile*',
  resolution_label: 'Resolution*',
  frame_size_label: 'Frame Size*',
  width_label: 'Width*',
  width_err: 'Width should be larger than 160 pixels',
  height_label: 'Height*',
  height_err: 'Height should be larger than 120 pixels',
  width_or_height: 'At least width or height should be provided',
  resize_mode_label: 'Resize Mode*',
  frame_rate_label: 'Frame rate*',
  frame_rate_err: 'Frame rate must be between 1 and 120 fps',
  keyframe_int_err: 'Keyframe int must be between 1 and 1000',
  min_keyframe_int_err: 'Min Keyframe Interval must be between 1 and 500',
  custom_frame_rate_label: 'Custom frame rate*',
  custom: 'Custom',
  auto: 'Auto',
  save_stream_btn: 'Save Stream',
  add_stream_btn: 'Add Stream',
  create_profile_btn: 'Create Profile',
  save_profile_btn: 'Save Profile',
  delete_stream_header: 'Delete stream?',
  delete_stream_text: 'Are you sure you want to delete the stream',
  cancel_btn: 'Cancel',
  total_jobs: 'total jobs',
  encoding_minutes: 'encoding minutes',
  profilesc_count: 'profiles',
  watch_folders_count: 'watch-folders',
  last_encodings: 'Last encodings',
  pending: 'Pending',
  processing: 'Processing',
  processing_live: 'Processing',
  input_failed: 'Input Failed',
  output_failed: 'Output Failed',
  failed: 'Failed',
  done: 'Done',
  success: 'Success',
  in_progress: 'In Progress',
  paused: 'Paused',
  issues: 'Issues',
  critical: 'Critical',
  no_jobs: 'You haven\'t created any transcoding task yet.',
  job_status_report: 'Job Status Report',
  encoding_jobs_header: 'Encoding Jobs',
  delete_selected_btn: 'Delete selected',
  format: 'Format',
  high_priority: 'High priority',
  delete_jobs_header: 'Delete jobs?',
  delete_job_header: 'Delete job?',
  delete_jobs_text: 'Are you sure you want to delete the selected job(s)?',
  delete_job_text: 'Are you sure you want to delete the job',
  delete_jobs_popup: 'Successfully removed',
  job_status: 'Job status',
  stream_tester: 'Stream Tester',
  submitted: 'Submitted',
  finished: 'Finished',
  total_job_time: 'Total job time',
  input: 'Input',
  file_size: 'File Size',
  segment_duration: 'segment duration',
  sec: 'sec',
  logs: 'Logs',
  events_count: 'events',
  video_duration: 'Video duration',
  audio_codec: 'Audio codec',
  video_codec: 'Video codec',
  video_streams: 'Video streams',
  video_stream: 'Video stream',
  audio_channels: 'Audio channels',
  new_file_transcoding: 'Create New Transcoding Job',
  new_file_transcoding_name_text: 'Specify task name (at least three characters) and transcoding profile:',
  input_url_text: 'Provide input URL:',
  input_label: 'Input*',
  login: 'Login',
  shared_key: 'Shared key',
  host_path: 'Host/Path',
  host_path_hint: '://host/path',
  secure: 'Secure',
  file_job_output_text: 'Add one or more output formats and specify the path(s) to the server folder to upload the result to:',
  general_tab: 'General',
  subtitles_tab: 'Subtitles',
  drm_tab: 'DRM',
  compress_tab: 'Compress',
  format_label: 'Format*',
  version_label: 'Version*',
  segment_size_label: 'Segment Size*',
  job_sub_text: 'Subtitles can only be added to video in the HLSv5 format.',
  job_sub_text2: 'You can add one or several links to subtitles in the WebVTT format. It is necessary to specify the subtitle language and a title that will be displayed in the player when selecting these subtitles.',
  lang_label: 'Lang',
  display_title_label: 'Display title',
  job_drm_text: 'The Widevine DRM protection is only supported for the <strong>MPEG-DASH</strong> format.<br/> The PlayReady DRM is for the <strong>MPEG-DASH</strong>, and <strong>MSS</strong> formats.',
  compress_text: 'If you need to compress the result into an archive, specify the archive\'s name below. The archives will be uploaded to all destination URLs specified in the output.',
  archive_label: 'Archive name',
  add_output_btn: 'Add another output',
  create_job_btn: 'Create Job',
  copy_btn: 'make a copy from a prev job',
  copy_job_header: 'Select a Job',
  remove_btn: 'Remove',
  watch_folder_header: 'Watch Folders',
  add_wf_btn: 'Add New Watch Folder',
  no_wf: 'You haven\'t created any watch folder yet',
  create_wf_btn: 'Create New Watch Folder',
  wf_name_text: 'Specify watch folder name (at least three characters) and encoding profile:',
  wf_name_label: 'Folder name*',
  encoding_profile_label: 'Encoding profile*',
  wf_input_text: 'Provide a FTP folder for our system to "watch" for new video files:',
  perform_once: 'Perform once',
  wf_output_text: 'Add one or more output formats and specify the path(s) to the server folder to upload the result to.',
  live_streams_header: 'Live Streams',
  no_live_streams_text: 'No live streams haven\'t been created yet',
  stop_stream_btn: 'Stop stream',
  start_stream_btn: 'Start stream',
  remove_stream_btn: 'Remove stream',
  create_live_stream: 'Create New Live Stream',
  edit_live_stream: 'Edit Live Stream',
  live_stream_name_text: 'Specify channel name (at least three characters) and encoding profile:',
  live_stream_input_text: 'Provide input:',
  type_label: 'Type',
  advance_settings_open: 'open advanced settings',
  advance_settings_close: 'close advanced settings',
  output_header: 'Output',
  live_output_text: 'Add one or more output formats and specify the path to the server to publish the stream:',
  destination_label: 'Destination',
  delete_streams_header: 'Delete streams?',
  delete_streams_text: 'Are you sure you want to delete the selected stream(s)?',
  delete_stream_success_text: 'The stream has been successfully removed',
  delete_streams_success_text: 'The streams have been successfully removed',
  segment_size_err: 'Must be between 1 and 60',
  copied: 'URL has been copied',
  open_btn: 'Open',
  input_live_header: 'Input',
  output_stream: 'Output stream',
  real_time_metrics: 'Real-time metrics',
  show_btn: 'Show',
  less: 'less',
  more: 'more',
  distrib_header: 'Channel Distributions',
  new_distrib_btn: 'Add New Distribution',
  no_distrib_text: 'No channel distributions haven\'t been created yet',
  new_distrib_header: 'Create New Distribution',
  edit_distrib_header: 'Edit Distribution',
  distrib_name_text: 'Specify distribution name (at least three characters):',
  distrib_cdn_text: 'Select CDN endpoint:',
  distrib_channels_text: 'Select channels:',
  channels_label: 'Channels*',
  channel_list: 'Channel List',
  export_csv_btn: 'Export CSV',
  distrib_warn_text1: 'Stream playback from your current IP address ',
  distrib_warn_text2: ' is not possible as it doesn’t belong to any of the IP whitelists.',
  recordings_header: 'Recordings',
  add_new_record_btn: 'Add New Record',
  record_period: 'Record period',
  channel: 'Channel',
  no_records_text: 'Record your live TV (only HLS streams are supported), so that you will be able to view it later on demand.',
  dvr_record_header: 'DVR Record',
  current_utc_time: 'Current UTC Time',
  jump_to_label: 'Jump To',
  play_from_btn: 'Play From',
  period: 'Period',
  earliest_recording: 'Earliest recording',
  recording_bitrates: 'Recording bitrates',
  input_url: 'Input URL',
  new_record_header: 'Add New Record',
  record_name_text: 'Specify record name (at least three characters):',
  record_channel_text: 'Select Live stream:',
  channel_label: 'Channel*',
  duration: 'Duration',
  record_period_text: 'Specify the recording period*:',
  days: 'days',
  hours: 'hours',
  your_limit: 'Your limit:',
};

export const RUSSIAN_TRANSLATIONS = {
  profile: 'Профиль',
  CDN: 'CDN',
  'File Transcoding': 'Файловое транскодирование',
  'Live Transcoding': 'Потоковое транскодирование',
  logout: 'Выйти',
  'New Endpoint': 'Новый Endpoint',
  Dashboard: 'Обзор',
  Endpoints: 'Endpoints',
  'Start New Job': 'Новое задание',
  Jobs: 'Задачи',
  'Watch Folders': 'Мониторинг FTP',
  'Encoding Profiles': 'Профили кодирования',
  'Start New Stream': 'Новый поток',
  Distributions: 'Раздачи',
  DVR: 'Записи трансляций',
  'Add New Record': 'Новая запись',
  Recordings: 'Записи',
  of: 'из',
  email: 'Адрес эл. почты',
  email_placeholder: 'Почта',
  password: 'Пароль',
  forgotten_password: 'Забыли пароль?',
  sign_in: 'Войти',
  sign_up_text: 'Нет аккаунта?',
  sign_up: 'Зарегистироваться',
  enter_email: 'Введите адрес эл. почты',
  non_empty_err: 'Обязательное поле',
  valid_email_err: 'Неправильный адрес эл. почты',
  unique_email_err: 'Эта почта уже зарегистрирована',
  name: 'Имя',
  enter_name: 'Введите ваше имя',
  company: 'Организация',
  enter_company: 'Название вашей организации',
  enter_password: 'Введите пароль',
  password_min_len_err: 'Пароль должен быть не менее 6 символов',
  confirm_password: 'Подтверждение Пароля',
  repeat_password: 'Повторите пароль',
  passwords_not_match_err: 'Пароли не совпадают',
  accept_terms: 'Принять условия использования',
  create_account: 'Создать аккаунт',
  already_have_account: 'Уже есть аккаунт?',
  signup_confirmation: 'Подтверждение регистрации',
  confirm_text: 'Мы отправили вам код активации. Проверьте электронную почту и нажмите на ссылку для подтверждения.',
  return_to_sign_in: 'Вернуться, чтобы войти в систему',
  submit: 'Отправить',
  password_reset_sent: 'Сброс пароля',
  password_reset_text: 'Мы отправили вам на электронную почту инструкции по настройке пароля. Вы должны получить их в ближайшее время. Если вы не получите электронное письмо, пожалуйста, убедитесь, что вы ввели адрес, на котором вы зарегистрировались, и проверьте папку спама.',
  edit_profile_btn: 'Редактировать профиль',
  change_my_password: 'Изменить пароль',
  edit_profile_header: 'Редактирования профиля',
  save_changes: 'Сохранить',
  profile_popup_success: 'Профиль успешно обновлен ',
  change_password_header: 'Изменение пароля',
  current_password: 'Текущий пароль*',
  new_password: 'Новый пароль*',
  confirm_new_password: 'Подтвердите новый пароль*',
  change_password_btn: 'Изменить пароль',
  password_change_popup: 'Пароль успешно обновлен',
  overview: 'Обзор',
  traffic_total: 'Суммарный трафик',
  cached_non_cached: 'Кэшировано / Не кэшировано',
  endpoint: 'Endpoint',
  traffic: 'Трафик',
  cached: 'Кэшировано',
  no_traffic: 'Нет данных',
  edit_endpoint: 'Редактировать Endpoint',
  new_endpoint_text: 'Укажите имя новой CDN Endpoint и http-адрес, откуда забирать данные:',
  title_label: 'Имя*',
  title: 'Название',
  title_req_err: 'Обязательное поле',
  title_min_err: 'Имя должно быть от 3 до 255 символов',
  ip_domain: 'IP-адрес или доменное имя*',
  http_hint: 'только http://',
  invalid_ip: 'Невалидный IP',
  required: 'обязательное поле',
  whitelist: 'Белый список',
  whitelist_text: 'Предоставьте список хостов IPv4/IP-сетей, которые будут разрешены данной CDN Endpoint. Изменения могут вступать в силу до 1 часа после сохранения.',
  host: 'хост',
  subnet: 'подсеть',
  mask: 'Маска',
  add_btn: 'Добавить',
  create_btn: 'Создать',
  save_btn: 'Сохранить',
  save_changes_popup: 'Изменения сохранены',
  new_endpoint_popup: 'CDN Endpoint успешно создана. CDN Endpoint будет активна примерно через 30-60 минут.',
  status: 'Статус',
  updated: 'Обновлено',
  no_cdn_text: 'Вы еще не настроили ни одной CDN Endpoint',
  endpoint_info: 'CDN Endpoint',
  created: 'Создано',
  state: 'Статус',
  error: 'Ошибка',
  origin_URL: 'Источник',
  whitlist_list: 'Белый список',
  no_whitelist: 'Ограничений по IP не установлено',
  delete_btn: 'Удалить',
  disable_btn: 'Отключить',
  enable_btn: 'Включить',
  disabled: 'Отключено',
  edit_btn: 'Редактировать',
  confirm_deletion: 'Подтверждение удаления',
  enter_endpoint: 'Введите имя CDN Endpoint*',
  enter_live_stream_name: 'Введите имя канала*',
  endpoint_remove_popup: 'CDN Endpoint успешно удалена',
  yes_btn: 'Да',
  no_btn: 'Нет',
  add_profile: 'Создать профиль',
  codecs: 'Кодеки',
  resolution: 'Разрешение',
  video_bitrate: 'Видео-битрейт',
  audio_bitrate: 'Аудио-битрейт',
  no_profiles: 'Вы не создали еще ни одного профиля кодирования.',
  audio: 'Аудио',
  channels: 'Каналы',
  bitrate: 'Битрейт',
  sample_rate: 'Частота дискретизации',
  video: 'Видео',
  encoder: 'Кодер',
  streams: 'Потоки',
  level: 'Уровень',
  bitrate_kbps: 'Битрейт, Kbps',
  resize_mode: 'Изменение размера кадра',
  frame_rate: 'Частота кадров',
  ref_frames: 'Референсные кадры',
  warning: 'Предупреждение',
  delete_profile_warning: 'Удаление профиля приведет к удалению всех связанных с ним задач транскодирования. Убедитесь, что никаких важных задач не связано с этим профилем.',
  proceed: 'Вы уверены, что хотите продолжить?',
  profile_name_enter: 'Введите имя профиля',
  profile_max_len_err: 'Имя должно быть менее 255 символов',
  invalid_profile_name_err: 'Неправильное имя профиля',
  new_profile_title: 'Новый профиль кодирования',
  edit_encoding_profile_header: 'Редактирование профиля',
  profile_name_text: 'Укажите имя профиля (минимум один символ):',
  profile_name_label: 'Имя профиля*',
  profile_audio_text: 'Укажите настройки звука:',
  codec_label: 'Кодек*',
  sample_rate_label: 'Частота дискретизации*',
  channel_count_label: 'Количество каналов*',
  bitrate_label: 'Битрейт*',
  custom_bitrate_label: 'Битрейт*',
  bitrate_required: 'Обязательное поле',
  bitrate_size_err: 'Битрейт должен быть от 0 до 1024 кбит/с',
  bitrate_video_size_err: 'Битрейт должен быть от 0 до 50000 кбит/с',
  same_as_source: 'Так же как в источнике',
  mono: 'Моно',
  stereo: 'Стерео',
  profile_video_text: 'Выберите видеокодек и укажите один или несколько видеопотоков:',
  encoder_label: 'Кодер*',
  stream: 'Поток',
  at_least_one_stream: 'Как минимум один поток должен быть указан',
  new_video_stream_btn: 'Добавить видеопоток',
  edit_video_stream_btn: 'Редактировать видеопоток',
  new_video_stream_label: 'Новый видеопоток',
  edit_video_stream_label: 'Редактирование видеопотока',
  level_label: 'Уровень*',
  profile_label: 'Профиль*',
  resolution_label: 'Разрешение*',
  frame_size_label: 'Размер кадра*',
  width_label: 'Ширина*',
  width_err: 'Ширина должна быть больше 160 пикселей',
  height_label: 'Высота*',
  height_err: 'Высота должна быть больше 120 пикселей',
  width_or_height: 'Как минимум нужно указать ширину или высоту',
  resize_mode_label: 'Изменение размера кадра*',
  frame_rate_label: 'Частота кадров*',
  frame_rate_err: 'Частота кадров должна быть от 1 до 120 кадров в секунду',
  keyframe_int_err: 'KeyFrame int должен быть от 1 до 1000',
  min_keyframe_int_err: 'Min Keyframe интервал должен быть от 1 до 500',
  custom_frame_rate_label: 'Частота кадров*',
  custom: 'Другое',
  auto: 'Авто',
  save_stream_btn: 'Сохранить',
  add_stream_btn: 'Добавить',
  create_profile_btn: 'Создать',
  save_profile_btn: 'Сохранить',
  delete_stream_header: 'Удалить поток?',
  delete_stream_text: 'Вы уверены, что хотите удалить поток',
  cancel_btn: 'Отмена',
  total_jobs: 'Всего задач',
  encoding_minutes: 'Минут кодирования',
  profilesc_count: 'профилей',
  watch_folders_count: 'мониторинг папок',
  last_encodings: 'Последнии задачи',
  pending: 'В ожидании',
  processing: 'Обработка',
  input_failed: 'Ошибка исходника',
  output_failed: 'Ошибка',
  failed: 'Ошибка',
  done: 'Успешно',
  success: 'Успешно',
  in_progress: 'Выполняется',
  paused: 'Остановлен',
  issues: 'Ошибки',
  processing_live: 'Обрабатывается',
  critical: 'Критическая ошибка',
  no_jobs: 'Вы еще не создали ни одной задачи транскодирования.',
  job_status_report: 'Обзор статусов задач',
  encoding_jobs_header: 'Задачи кодирования',
  delete_selected_btn: 'Удалить выбранное',
  high_priority: 'Высокий приоритет',
  delete_jobs_header: 'Удалить задачи?',
  delete_job_header: 'Удалить задачу?',
  delete_jobs_text: ' выбранные задания?',
  delete_job_text: 'Вы уверены, что хотите удалить задачу',
  delete_jobs_popup: 'Успешно удалено',
  format: 'Формат',
  job_status: 'Статус задачи',
  stream_tester: 'Проверка видео',
  submitted: 'Создано',
  finished: 'Завершено',
  total_job_time: 'Время выполнения',
  input: 'Источник',
  file_size: 'Размер файла',
  segment_duration: 'длина сегмента',
  sec: 'сек.',
  logs: 'Журнал событий',
  events_count: 'событий',
  video_duration: 'Длительность',
  audio_codec: 'Аудио кодек',
  video_codec: 'Видео кодек',
  video_streams: 'Видеопотоков',
  video_stream: 'Видеопоток',
  audio_channels: 'Аудио-каналов',
  new_file_transcoding: 'Новое задание',
  new_file_transcoding_name_text: 'Укажите имя задачи (не менее трех символов) и профиль транскодирования:',
  input_url_text: 'Укажите источник видео:',
  input_label: 'Источник*',
  login: 'Логин',
  shared_key: 'Ключ',
  host_path: 'Хост/Путь',
  host_path_hint: '://хост/путь',
  secure: 'Шифрование',
  file_job_output_text: 'Добавьте один или несколько результатов кодирования: укажите формат и путь для выгрузки результата.',
  general_tab: 'Базовые настройки',
  subtitles_tab: 'Субтитры',
  drm_tab: 'DRM',
  compress_tab: 'Сжатие',
  format_label: 'Формат*',
  version_label: 'Версия*',
  segment_size_label: 'Размер сегмента*',
  job_sub_text: 'Субтитры могут быть добавлены только к видео в формате HLSV5.',
  job_sub_text2: 'Вы можете добавить одну или несколько ссылок на субтитры в формате WebVTT. Необходимо указать язык субтитров и название, которое будет отображаться в меню выбора данных субтитров в плейере.',
  lang_label: 'Язык',
  display_title_label: 'Заголовок',
  job_drm_text: 'Widevine DRM поддерживается только для формата <strong>MPEG-DASH</strong>.<br/> PlayReady DRM предназначен для <strong>MPEG-DASH</strong> и <strong>MSS</strong>-форматов.',
  compress_text: 'Если вам необходимо упаковать результат в архив, укажите имя архива ниже.',
  archive_label: 'Имя архива',
  add_output_btn: 'Добавить вывод',
  create_job_btn: 'Создать',
  copy_btn: 'скопировать предыдущее задание',
  copy_job_header: 'Выберете задачу',
  remove_btn: 'Удалить',
  watch_folder_header: 'Мониторинг FTP директорий',
  add_wf_btn: 'Добавить',
  no_wf: 'Нет данных',
  create_wf_btn: 'Добавление мониторинга FTP-директории',
  wf_name_text: 'Укажите название задачи мониторинга (минимум 3 символа) и выберите профиль кодирования:',
  wf_name_label: 'Имя задания*',
  encoding_profile_label: 'Профиль кодирования*',
  wf_input_text: 'Укажите FTP-директорию, которая будет сканироваться на регулярной основе:',
  perform_once: 'Просканировать только раз',
  wf_output_text: 'Добавьте один или несколько форматов кодирования и укажите, куда выгружать результат:',
  live_streams_header: 'Потоковое видео',
  no_live_streams_text: 'Нет данных',
  stop_stream_btn: 'Остановить поток',
  start_stream_btn: 'Запустить поток',
  remove_stream_btn: 'Удалить поток',
  create_live_stream: 'Добавление потока',
  edit_live_stream: 'Редактирование потока',
  live_stream_name_text: 'Укажите название потока (минимум 3 символа) и выберите профиль кодирования:',
  live_stream_input_text: 'Укажите входной поток:',
  type_label: 'Тип',
  advance_settings_open: 'Открыть дополнительные настройки',
  advance_settings_close: 'Закрыть дополнительные настройки',
  output_header: 'Вывод',
  live_output_text: 'Добавьте один или несколько исходящих форматов потока и укажите путь публикации:',
  destination_label: 'Путь',
  delete_streams_header: 'Удалить потоки?',
  delete_streams_text: 'Вы уверены, что хотите удалить выбранные потоки?',
  delete_stream_success_text: 'Поток успешно удален',
  delete_streams_success_text: 'Потоки успешно удалены',
  segment_size_err: 'От 1 до 60 сек',
  copied: 'URL скопирован',
  open_btn: 'Открыть',
  input_live_header: 'Входящий поток',
  output_stream: 'Исходящий поток',
  real_time_metrics: 'Метрики в режиме реального времени',
  show_btn: 'Показать',
  less: 'меньше',
  more: 'больше',
  distrib_header: 'Распространение каналов',
  new_distrib_btn: 'Добавить раздачу',
  no_distrib_text: 'Вы еще не создали ни одной раздачи',
  new_distrib_header: 'Новая раздача канала',
  edit_distrib_header: 'Редактирование раздачи',
  distrib_name_text: 'Укажите имя раздачи (минимум 3 символа):',
  distrib_cdn_text: 'Выберите CDN endpoint:',
  distrib_channels_text: 'Выберите каналы:',
  channels_label: 'Каналы*',
  channel_list: 'Список каналов',
  export_csv_btn: 'Скачать CSV',
  distrib_warn_text1: 'Воспроизведение потоков с вашего IP-адреса ',
  distrib_warn_text2: ' не возможно, так как ваш адрес не входит в список разрешенных IP-адресов',
  recordings_header: 'Записи',
  add_new_record_btn: 'Добавить запись',
  record_period: 'Период записи',
  channel: 'Канал',
  no_records_text: 'Запись потокового видео (мы поддерживаем запись только HLS-потоков) позволяет создать видеоконтент в режиме "видео по запросу"',
  dvr_record_header: 'DVR Запись',
  current_utc_time: 'Текущее UTC время',
  jump_to_label: 'Период',
  play_from_btn: 'Выбрать период',
  period: 'Период',
  earliest_recording: 'Первая запись',
  recording_bitrates: 'Записываемые битрейты',
  input_url: 'URL источника',
  new_record_header: 'Добавление записи',
  record_name_text: 'Укажите имя записи (минимум три символа):',
  record_channel_text: 'Выберите канал:',
  channel_label: 'Канал*',
  duration: 'Период',
  record_period_text: 'Укажите период записи*:',
  days: 'дней',
  hours: 'часов',
  your_limit: 'Текущий лимит:',
};




